import React from "react";
import PropTypes from "prop-types";
import Slideshow from "../Slideshow";
import ExhibitionTeaser from "../ExhibitionTeaser";
import { exhibitionShape } from "../shapes";

function ExhibitionSlider({ exhibitions, active, onUpdate }) {
  const renderSlide = (exhibition) => (
    <ExhibitionTeaser
      key={exhibition.id}
      exhibition={exhibition}
      imageWidth={894}
      theme="overlay"
    />
  );

  return (
    <Slideshow
      renderSlide={renderSlide}
      slides={exhibitions}
      active={active}
      onUpdate={onUpdate}
    />
  );
}

ExhibitionSlider.displayName = "ExhibitionsLanding.Current.Slideshow";
ExhibitionSlider.propTypes = {
  exhibitions: PropTypes.arrayOf(PropTypes.shape(exhibitionShape).isRequired),
  active: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default ExhibitionSlider;
